import styled from "styled-components";

export const SpecialPriceAttachmentWrapper = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 0.5rem;
    position: relative;
    overflow-y: auto;
`;
